import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import StepAvatar from './StepAvatar';
import StepSeparator from './StepSeparator';

const styles = () => ({
  root: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
  },
  rootPositionBefore: {
    transform: 'translateX(-100%)',
    left: 0,
  },
  rootPositionAfter: {
    transform: 'translateX(100%)',
    right: 0,
  },
});

const UnselectedSteps = ({
  className,
  classes,
  steps,
  position,
}) => {
  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootPositionBefore]: position === 'before',
        [classes.rootPositionAfter]: position === 'after',
      })}
    >
      {steps.map((step) => {
        return (
          <React.Fragment
            key={step.stepId}
          >
            {position === 'after' ? (
              <StepSeparator />
            ) : null}
            <StepAvatar
              step={step}
              size={'md'}
            />
            {position === 'before' ? (
              <StepSeparator />
            ) : null}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

UnselectedSteps.defaultProps = {
  className: '',
};

UnselectedSteps.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  position: PropTypes.oneOf(['before', 'after']).isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withStyles(styles)(UnselectedSteps);
